import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import authHeader from "../Services/auth-header";
import { useDispatch, useSelector } from "react-redux";
import { refreshToken } from "../Services/auth.service";
import { CartUpdatedTrue, SidePriceUpdate, SideDiscountedPrice } from "../Actions/types";
import { CapitalizeAllWords, NumToFa , convertToPersian } from "../Functions/TextTransform";
import GetPrice from "../Functions/GetPrice";
import NumberToPersianWord from "number_to_persian_word";
import { useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import QTY from "./QTY";
import QTYSmallBasket from "./QTYSmallBasket";
import {
  imgUrl,
  baseURLGetCart,
  baseURLEditProject,
  baseAddCountProject,
  baseURLAddProduct,
  baseURLDeleteBasketProject,
} from "../config/api";
import { DkSideCartFabricMiniCart, mergeDkFabricCartObj } from "./DkSideCartFabricDisplay";

function RenderSideCart({ cartObjects, setCartCount }) {
  const { isLoggedIn } = useSelector((state) => state.auth);
  const { t } = useTranslation();

  const draperyRef = useRef({});
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname
      .split("")
      .slice(1, 3)
      .join("")
  );
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 923px)" });
  const [cartItems, setCartItems] = useState([]);
  const [loadingItemId, setLoadingItemId] = useState(null);
  function setBasketNumber(cart, refIndex, numValue, type, minusPlus, len) {
    if (isLoggedIn) {
      setLoadingItemId(refIndex);
      let temp = JSON.parse(JSON.stringify(cart))["CartDetails"];
      let tempProjectContainer = temp.find((opt) => opt["CartDetailId"] === refIndex);

      if (Object.keys(tempProjectContainer).length !== 0) {
        let tempProject = {};
        if (tempProjectContainer["TypeId"] === 6403) {
          tempProject = tempProjectContainer["SewingOrder"];
          tempProject["Count"] = tempProject["WindowCount"];
        } else {
          tempProject = tempProjectContainer;
        }
        if (type === 1) {
          if (minusPlus !== undefined) {
            addProduct(tempProject["ProductId"], minusPlus, len);
          } else {
            if (parseInt(numValue) > 10) {
              addProduct(tempProject["ProductId"], 10, len);
            } else if (parseInt(numValue) <= 0) {
              deleteBasketProject(refIndex);
            } else {
              addProduct(
                tempProject["ProductId"],
                parseInt(numValue) - parseInt(tempProject["Count"]),
                len
              );
            }
          }
        } else {
          if (minusPlus !== undefined) {
            if (tempProject["Count"] + minusPlus <= 0 || tempProject["Count"] + minusPlus > 10)
              setBasketNumber(cart, refIndex, tempProject["Count"] + minusPlus, type);
            else {
              tempProject["Count"] = tempProject["Count"] + minusPlus;
              tempProject["WindowCount"] = tempProject["Count"];
              editBasketProject(tempProject, minusPlus, refIndex);
            }
          } else {
            let oldCount = tempProject["Count"];
            if (numValue === "") {
              tempProject["Count"] = 1;
              editBasketProject(tempProject, 1 - oldCount);
            } else if (!isNaN(numValue) || numValue === 10 || numValue === "10") {
              if (parseInt(numValue) > 10) {
                tempProject["Count"] = 10;
                editBasketProject(tempProject, 10 - oldCount);
              } else if (parseInt(numValue) <= 0) {
                deleteBasketProject(refIndex);
              } else {
                tempProject["Count"] = parseInt(numValue);
                editBasketProject(tempProject, parseInt(numValue) - oldCount);
              }
            }
          }
        }
      }
    } else {
      let temp = [];
      let typeString = "";
      let cartObj = {};
      if (type === 0) {
        if (localStorage.getItem("cart") !== null) {
          cartObj = JSON.parse(localStorage.getItem("cart"));
          temp = cartObj["drapery"];
          typeString = "drapery";
        } else {
          renderCart();
        }
      } else if (type === 1) {
        if (localStorage.getItem("cart") !== null) {
          cartObj = JSON.parse(localStorage.getItem("cart"));
          temp = cartObj["drapery"];
          typeString = "drapery";
        } else {
          renderCart();
        }
      }

      if (temp?.length > 0 && type === 0) {
        if (minusPlus !== undefined) {
          if (temp[refIndex] === undefined) {
            cartObj[typeString] = temp;
            localStorage.setItem("cart", JSON.stringify(cartObj));
            setCartCount(cartObj.drapery.length);
            renderCart(cartObj);
          } else {
            if (
              temp[refIndex]["Count"] + minusPlus <= 0 ||
              temp[refIndex]["Count"] + minusPlus > 50
            )
              setBasketNumber(cart, refIndex, temp[refIndex]["Count"] + minusPlus, type);
            else {
              temp[refIndex]["Count"] = temp[refIndex]["Count"] + minusPlus;
              temp[refIndex]["WindowCount"] = temp[refIndex]["Count"];
              temp[refIndex]["PreorderText"]["WindowCount"] = temp[refIndex]["Count"];
              cartObj[typeString] = temp;
              localStorage.setItem("cart", JSON.stringify(cartObj));
              setCartCount(cartObj.drapery.length);
              renderCart(cartObj);
            }
          }
        } else {
          if (!isNaN(numValue) || numValue === 50 || numValue === "50") {
            if (numValue > 50) {
              temp[refIndex]["Count"] = 50;
              temp[refIndex]["WindowCount"] = temp[refIndex]["Count"];
              temp[refIndex]["PreorderText"]["WindowCount"] = temp[refIndex]["Count"];
              cartObj[typeString] = temp;
              localStorage.setItem("cart", JSON.stringify(cartObj));
              setCartCount(cartObj.drapery.length);
              renderCart(cartObj);
            } else if (numValue <= 0) {
              draperyRef.current[refIndex].className = "custom_cart_item is_loading2";
              setTimeout(() => {
                draperyRef.current[refIndex].className = "custom_cart_item";
                temp.splice(refIndex, 1);
                cartObj[typeString] = temp;
                localStorage.setItem("cart", JSON.stringify(cartObj));
                setCartCount(cartObj.drapery.length);
                renderCart(cartObj);
              }, 1500);
            } else {
              temp[refIndex]["Count"] = numValue;
              temp[refIndex]["WindowCount"] = temp[refIndex]["Count"];
              temp[refIndex]["PreorderText"]["WindowCount"] = temp[refIndex]["Count"];
              cartObj[typeString] = temp;
              localStorage.setItem("cart", JSON.stringify(cartObj));
              console.log(`cartObj`, cartObj);
              setCartCount(cartObj.drapery.length);
              renderCart(cartObj);
            }
          } else {
            temp[refIndex]["Count"] = 1;
            temp[refIndex]["WindowCount"] = temp[refIndex]["Count"];
            temp[refIndex]["PreorderText"]["WindowCount"] = temp[refIndex]["Count"];
            cartObj[typeString] = temp;
            localStorage.setItem("cart", JSON.stringify(cartObj));
            setCartCount(cartObj.drapery.length);
            renderCart(cartObj);
          }
        }
      } else if (temp?.length > 0 && type === 1) {
        let tempIndex = cartObj["drapery"].findIndex(
          (obj) => obj["ProductId"] === refIndex["ProductId"]
        );
        if (tempIndex !== -1) {
          if (minusPlus !== undefined) {
            if (temp[tempIndex] === undefined) {
              cartObj[typeString] = temp;
              localStorage.setItem("cart", JSON.stringify(cartObj));
              renderCart(cartObj);
            } else {
              if (
                temp[tempIndex]["Count"] + minusPlus <= 0 ||
                temp[tempIndex]["Count"] + minusPlus > 50
              )
                setBasketNumber(cart, refIndex, temp[tempIndex]["Count"] + minusPlus, type);
              else {
                temp[tempIndex]["Count"] = temp[tempIndex]["Count"] + minusPlus;
                cartObj[typeString] = temp;
                localStorage.setItem("cart", JSON.stringify(cartObj));
                renderCart(cartObj);
              }
            }
          } else {
            if (!isNaN(numValue) || numValue === 50 || numValue === "50") {
              if (numValue > 50) {
                temp[tempIndex]["Count"] = 50;
                cartObj[typeString] = temp;
                localStorage.setItem("cart", JSON.stringify(cartObj));
                renderCart(cartObj);
              } else if (numValue <= 0) {
                draperyRef.current[tempIndex].className = "custom_cart_item is_loading2";
                setTimeout(() => {
                  draperyRef.current[tempIndex].className = "custom_cart_item";
                  temp.splice(tempIndex, 1);
                  cartObj[typeString] = temp;
                  localStorage.setItem("cart", JSON.stringify(cartObj));
                  renderCart(cartObj);
                }, 1500);
              } else {
                temp[tempIndex]["Count"] = numValue;
                cartObj[typeString] = temp;
                localStorage.setItem("cart", JSON.stringify(cartObj));
                renderCart(cartObj);
              }
            } else {
              temp[tempIndex]["Count"] = 1;
              cartObj[typeString] = temp;
              localStorage.setItem("cart", JSON.stringify(cartObj));
              renderCart(cartObj);
            }
          }
        } else {
          cartObj[typeString] = temp;
          localStorage.setItem("cart", JSON.stringify(cartObj));
          renderCart(cartObj);
        }
      }
    }
  }

  function getCart() {
    if (isLoggedIn) {
      axios
        .get(baseURLGetCart, {
          headers: authHeader(),
        })
        .then((response) => {
          dispatch({
            type: CartUpdatedTrue,
            payload: { mainCart: response["data"] },
          });
          renderCart(response["data"]);
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            refreshToken().then((response2) => {
              if (response2 !== false) {
                getCart();
              } else {
                navigate("/" + pageLanguage);
              }
            });
          } else {
          }
        });
    }
  }
  // custom_cart_item
  function editBasketProject(projectObj, countChange = 1, refIndex) {
    if (projectObj["TypeId"] && projectObj["TypeId"] === 6401) {
    } else {
      projectObj["WindowCount"] = projectObj["Count"];
      projectObj["PreorderText"]["WindowCount"] = projectObj["Count"];
      projectObj["PreorderText"]["Count"] = projectObj["Count"];
    }
    if (isLoggedIn) {
      const el = draperyRef.current[refIndex];
      if (el) {
        el.classList.add("is_loading2");
      }
      axios
        .post(baseAddCountProject, null, {
          headers: authHeader(),
          params: {
            sewingOrderId: projectObj["SewingOrderId"],
            count: countChange,
          },
        })
        .then((response) => {
          // getCart();
          dispatch({
            type: CartUpdatedTrue,
            payload: { mainCart: response["data"] },
          });
          renderCart(response["data"]);
          setLoadingItemId(null);
          // حذف کلاس
          if (el) {
            el.classList.remove("is_loading2");
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            refreshToken().then((response2) => {
              if (response2 !== false) {
                editBasketProject(projectObj, countChange);
              } else {
                navigate("/" + pageLanguage);
              }
            });
          }
          setLoadingItemId(null);
          if (el) {
            el.classList.remove("is_loading2");
          }
        });
    } else {
      axios
        .post(baseURLEditProject, projectObj, {
          headers: authHeader(),
        })
        .then(() => {
          getCart();
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            refreshToken().then((response2) => {
              if (response2 !== false) {
                editBasketProject(projectObj);
              } else {
                navigate("/" + pageLanguage);
              }
            });
          }
        });
    }
  }

  function addProduct(productId, count, len) {
    if (isLoggedIn) {
      const params = {
        productId: productId,
        count: count,
      };

      if (len !== null && len !== undefined) {
        params.len = len;
      }

      axios
        .post(
          baseURLAddProduct,
          {},
          {
            headers: authHeader(),
            params: params,
          }
        )
        .then((response) => {
          dispatch({
            type: CartUpdatedTrue,
            payload: { mainCart: response["data"] },
          });
          renderCart(response["data"]);
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            refreshToken().then((response2) => {
              if (response2 !== false) {
                addProduct(productId, count, len);
              } else {
                addProduct(productId, count, len);
              }
            });
          }
        });
    }
  }

  function deleteBasketProject(refIndex) {
    if (draperyRef.current[refIndex]) {
      draperyRef.current[refIndex].className = "custom_cart_item is_loading2";
    }
    axios
      .post(
        baseURLDeleteBasketProject + "/" + refIndex,
        {},
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (draperyRef.current[refIndex]) {
          draperyRef.current[refIndex].className = "custom_cart_item";
        }
        dispatch({
          type: CartUpdatedTrue,
          payload: { mainCart: response["data"] },
        });
        renderCart(response["data"]);
        if (response["data"].CartDetails && response.status === 200) {
          setCartCount(response["data"].CartDetails.length);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              deleteBasketProject(refIndex);
            } else {
              navigate("/" + pageLanguage);
            }
          });
        } else {
          if (draperyRef.current[refIndex]) {
            draperyRef.current[refIndex].className = "custom_cart_item";
          }
        }
      });
  }

  useEffect(() => {
    if (Object.keys(cartObjects)?.length) {
      renderCart(cartObjects);
    } else {
      renderCart({});
    }
  }, [cartObjects]);
  useEffect(() => {
    // اسکرول به بالای صفحه
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // اسکرول نرم
    });
  }, []);
  // console.log(`cartObjects`, cartObjects);
  function renderCart(cartObjects) {
    let temp1 = [];
    let cartCount = 0;
    // کاربر لاگین شده
    if (isLoggedIn && cartObjects["CartDetails"]) {
      let totalPrice = cartObjects["PayableAmount"];

      let draperies = cartObjects["CartDetails"].filter((object1) => {
        return object1["TypeId"] === 6403;
      });

      let products = cartObjects["CartDetails"].filter((object1) => {
        return object1["TypeId"] === 6401;
      });

      let swatches = cartObjects["CartDetails"].filter((object1) => {
        return object1["TypeId"] === 6402;
      });

      let promiseArr = [];
      if (draperies.length || products.length) {
        [...draperies, ...products]
          .sort(function(a, b) {
            return b["CartDetailId"] - a["CartDetailId"] || b["SewingOrderId"] - a["SewingOrderId"];
          })
          .forEach((tempObj, i) => {
            promiseArr[i] = new Promise((resolve, reject) => {
              if (tempObj["TypeId"] === 6403) {
                let obj = mergeDkFabricCartObj(
                  tempObj["SewingOrder"]["PreorderText"] || {},
                  tempObj["SewingOrder"] || {}
                );
                let DiscountedPrice = tempObj["DiscountedPrice"];
                let roomName =
                  obj["WindowDescription"] === undefined || obj["WindowDescription"] === ""
                    ? ""
                    : " / " + obj["WindowDescription"];
                if (obj["SewingModelId"] === "0326") {
                  temp1[i] = (
                    <li
                      className="custom_cart_item"
                      key={"drapery" + i}
                      ref={(ref) => (draperyRef.current[tempObj["CartDetailId"]] = ref)}
                    >
                      <div className="custom_cart_item_image_container 1">
                        <img
                          src={imgUrl(obj["PhotoUrl"])}
                          alt=""
                          className="custom_cart_item_img img-fluid"
                        />
                      </div>
                      <div className="custom_cart_item_desc 1">
                        <div className="custom_cart_item_desc_container">
                          <h1 className="custom_cart_item_desc_name">
                            {pageLanguage === "fa"
                              ? obj["ModelNameFa"] + " سفارشی "
                              : "Custom " + obj["ModelNameEn"]}
                          </h1>
                          <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() =>
                              setBasketNumber(cartObjects, tempObj["CartDetailId"], 0, 0)
                            }
                          />
                        </div>
                        <DkSideCartFabricMiniCart obj={obj} pageLanguage={pageLanguage} t={t} />
                        <div className="custom_cart_item_desc_container">
                          <h2 className="custom_cart_item_desc_detail">
                            {pageLanguage === "fa"
                              ? obj["RoomNameFa"] + roomName
                              : obj["RoomNameEn"] + roomName}
                          </h2>
                        </div>
                        
                        <div className="custom_cart_item_desc_container">
                          <div className="custom_cart_item_desc_qty">
                            <QTY
                              qty={tempObj["SewingOrder"]["WindowCount"]}
                              minQty={1}
                              maxQty={10}
                              isReadOnly={false}
                              pageLanguage={pageLanguage}
                              NumberToPersianWord={NumberToPersianWord}
                              handleIncrement={() =>
                                setBasketNumber(cartObjects, tempObj["CartDetailId"], 0, 0, 1)
                              }
                              handleDecrement={() =>
                                setBasketNumber(cartObjects, tempObj["CartDetailId"], 0, 0, -1)
                              }
                              handleInputChange={(value) =>
                                setBasketNumber(cartObjects, tempObj["CartDetailId"], value, 0)
                              }
                            />
                          </div>

                          <p className="custom_cart_item_end_price 12">
                            {GetPrice(obj["Price"], pageLanguage, t("TOMANS"), isTabletOrMobile)}
                          </p>
                        </div>
                      </div>
                    </li>
                  );
                  resolve();
                } else {
                  temp1[i] = (
                    <li
                      className="custom_cart_item"
                      key={"drapery" + i}
                      ref={(ref) => (draperyRef.current[tempObj["CartDetailId"]] = ref)}
                    >
                      <div className="custom_cart_item_image_container 2">
                        <img
                          src={imgUrl(obj["PhotoUrl"])}
                          alt=""
                          className="custom_cart_item_img img-fluid"
                        />
                      </div>
                      <div className="custom_cart_item_desc 2">
                        <div className="custom_cart_item_desc_container">
                          <h1 className="custom_cart_item_desc_name">
                            {pageLanguage === "fa"
                              ? obj["ModelNameFa"] + " سفارشی "
                              : "Custom " + obj["ModelNameEn"]}
                          </h1>
                          <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() =>
                              setBasketNumber(cartObjects, tempObj["CartDetailId"], 0, 0)
                            }
                          />
                        </div>
                     
                        {
                          obj["FabricDesignEn"] && obj["FabricDesignEn"] !== "undefined" && obj["FabricDesignEn"] !== "null" && obj["FabricDesignEn"] !== "" && ( <div className="custom_cart_item_desc_container custom_cart_item_desc_container_fabrics 1">
                            <h2 className="custom_cart_item_desc_detail 18">
                              {pageLanguage === "fa"
                                ? obj["FabricDesignFa"] + " / " + obj["FabricColorFa"]
                                : CapitalizeAllWords(
                                    obj["FabricDesignEn"] + " / " + obj["FabricColorEn"]
                                  )}
                            </h2>
                          </div> )}
                      {
                        obj["FabricDesignEn2"] && obj["FabricDesignEn2"] !== "undefined" && obj["FabricDesignEn2"] !== "null" && obj["FabricDesignEn2"] !== "" && (<div className="custom_cart_item_desc_container custom_cart_item_desc_container_fabrics 1">
                          {obj["FabricId2"] && (
                            <h2 className="custom_cart_item_desc_detail 19">
                              {pageLanguage === "fa"
                                ? obj["FabricDesignFa2"] + " / " + obj["FabricColorFa2"]
                                : CapitalizeAllWords(obj["FabricDesignEn2"]) + " / " + CapitalizeAllWords(obj["FabricColorEn2"])}
                            </h2>
                          )}
                        </div>)}
                       
                        {obj["SewingModelId"] !== "0097" &&
                          obj["SewingModelId"] !== "0303" &&
                          obj["SewingModelId"] !== "0327" &&
                          obj["SewingModelId"] !== "0328" &&
                          obj["SewingModelId"] !== "0324" &&
                          obj["SewingModelId"] !== "0325" && 
                          obj["PrivacyLayer"] &&   obj["PrivacyLayer"] !== "None" && (
                            <>
                              <div className="custom_cart_item_desc_container custom_cart_item_desc_container_fabrics 2">
                                {obj["PrivacyLayer"] &&
                                  obj["PrivacyLayer"] !== "none" &&
                                  obj["SheersDesignEn"] &&
                                  obj["SheersColorEn"] && (
                                    <h2 className="custom_cart_item_desc_detail">
                                      {pageLanguage === "fa"
                                        ? obj["SheersDesignFa"] + " / " + obj["SheersColorFa"]
                                        : CapitalizeAllWords(
                                            obj["SheersDesignEn"] + " / " + obj["SheersColorEn"]
                                          )}
                                    </h2>
                                  )}
                              </div>
                            </>
                          )}
                          {(() => {
                            console.log(`obj`, obj);
                          })()}
                        <div className="custom_cart_item_desc_container">
                          <h2 className="custom_cart_item_desc_detail 1">
                            {pageLanguage === "fa"
                              ? obj["RoomNameFa"] + " / " + obj["WindowDescription"]
                              : obj["RoomNameEn"] + " / " + obj["WindowDescription"]}
                          </h2>
                        </div>
                        {/* <div className="custom_cart_item_desc_container"></div> */}
                        <div className="custom_cart_item_desc_container">
                          <div className="custom_cart_item_desc_qty">
                            <QTYSmallBasket
                              qty={tempObj["SewingOrder"]["WindowCount"]}
                              minQty={1}
                              maxQty={10}
                              isReadOnly={false}
                              isLoading={loadingItemId === tempObj["CartDetailId"]}
                              pageLanguage={pageLanguage}
                              NumberToPersianWord={NumberToPersianWord}
                              onIncrement={() => {
                                setBasketNumber(cartObjects, tempObj["CartDetailId"], 0, 0, 1);
                              }}
                              onDecrement={() => {
                                setBasketNumber(cartObjects, tempObj["CartDetailId"], 0, 0, -1);
                              }}
                              onInputChange={(value) => {
                                setBasketNumber(cartObjects, tempObj["CartDetailId"], value, 0);
                              }}
                            />
                          </div>

                          <p className="custom_cart_item_end_price 10">
                            {GetPrice(
                              DiscountedPrice * tempObj["Count"],
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )}
                          </p>
                        </div>
                      </div>
                    </li>
                  );
                  resolve();
                }
              } else {
                // کالاهای عددی
                let obj = tempObj;
                let UnitMeasureId = obj["UnitMeasureId"];
                let SewingModelId = obj["SewingModelId"];
                let UnitId = obj["UnitId"];
                let ProductGroupId = obj["ProductGroupId"];
                temp1[i] = (
                  <li
                    className="custom_cart_item"
                    key={"products" + i}
                    ref={(ref) => (draperyRef.current[obj["CartDetailId"]] = ref)}
                    style={{
                      paddingBottom:
                        obj["DiscountedPrice"] === obj["UnitPrice"] ? "1rem" : "2.4rem",
                    }}
                  >
                    <div className="custom_cart_item_image_container 3">
                      <img
                        src={imgUrl(obj["PhotoUrl"])}
                        alt=""
                        className="custom_cart_item_img img-fluid"
                      />
                    </div>

                    <div className="custom_cart_item_desc 3">
                      <div className="custom_cart_item_desc_container">
                        <h1 className="custom_cart_item_desc_name">
                          {pageLanguage === "fa" ? obj["ProductName"] : obj["ProductEnName"]}{" "}
                          {pageLanguage === "fa"
                            ? obj["SewingModelName"]
                            : obj["SewingModelEnName"]}
                          {obj["ProductGroupId"] === "10" && t("Fabric By The Meter_bg")}
                        </h1>

                        <button
                          type="button"
                          className="btn-close"
                          aria-label="Close"
                          onClick={() => deleteBasketProject(obj["CartDetailId"])}
                        />
                      </div>
                      <div className="custom_cart_item_desc_container">
                        <h2 className="custom_cart_item_desc_detail">
                          {t("Color: ")}
                          {pageLanguage === "en"
                            ? CapitalizeAllWords(obj["ColorEnName"])
                            : obj["ColorName"]}
                        </h2>
                      </div>

                      {obj["Diameter"] && obj["ProductGroupId"] !== "10" && (
                        <div className="custom_cart_item_desc_container">
                          <h2 className="custom_cart_item_desc_detail">
                            <span>{t("Diameter")}:</span>
                            <span style={{ paddingLeft: "0.2rem" }}>
                              {pageLanguage === "en" ? obj["Diameter"] : obj["Diameter"]}
                              {t("MM")}
                            </span>
                          </h2>
                        </div>
                      )}

                      {obj["ProductGroupId"] === "100605" && (
                        <div className="custom_cart_item_desc_container">
                          <h2 className="custom_cart_item_desc_detail">
                            <span>{t("Length: ")}</span>
                            <span>
                              {pageLanguage === "en" ? obj["ItemLength"] : obj["ItemLength"]}
                              <span>{t("CM")}</span>
                            </span>
                          </h2>
                        </div>
                      )}

                      {UnitId !== 1 &&
                        ProductGroupId !== "100607" &&
                        ProductGroupId !== "100606" &&
                        ProductGroupId !== "100608" &&
                        ProductGroupId !== "100603" &&
                        ProductGroupId !== "100605" &&
                        ProductGroupId !== "10" &&
                        ProductGroupId !== "100701" && (
                          <div className="custom_cart_item_desc_container">
                            <h2 className="custom_cart_item_desc_detail">
                              {t("Size: ")}
                              {pageLanguage === "en"
                                ? obj["ProductSizeEnName"]
                                : convertToPersian(obj["ProductSizeName"])}
                            </h2>
                          </div>
                        )}
                      {UnitId !== 1 &&
                        obj.LiningTypeEnName !== undefined && obj.LiningTypeEnName != null &&
                        SewingModelId !== "0303" &&
                        ProductGroupId !== "500204" &&
                        ProductGroupId !== "100607" &&
                        ProductGroupId !== "300301" &&
                        ProductGroupId !== "100606" &&
                        ProductGroupId !== "100608" &&
                        ProductGroupId !== "100603" &&
                        ProductGroupId !== "100605" &&
                        ProductGroupId !== "10" &&
                        ProductGroupId !== "100203" &&
                        SewingModelId !== "0324" &&
                        SewingModelId !== "0325" &&
                        ProductGroupId !== "100701" &&
                        ProductGroupId !== "300302" &&
                        ProductGroupId !== "300303" &&
                        ProductGroupId !== "300304" && (
                          <div className="custom_cart_item_desc_container">
                            <h2 className="custom_cart_item_desc_detail">
                              {t("Lining: ")}
                              {pageLanguage === "fa" ? obj.LiningTypeName : obj.LiningTypeEnName}
                            </h2>
                          </div>
                        )}
                      {UnitId !== 1 &&
                        obj["ControlPosition"] !== undefined &&
                        (SewingModelId === "0325" || SewingModelId === "0324" || SewingModelId === "0303" || SewingModelId === "0327" || SewingModelId === "0328") && (
                          <div className="custom_cart_item_desc_container">
                            <h2 className="custom_cart_item_desc_detail">
                              {t("Control Position: ")}
                              {obj["ControlPosition"] ? t("Right") : t("Left")}
                            </h2>
                          </div>
                        )}
                      <div className="custom_cart_item_desc_container">
                        {/* <h2 className="custom_cart_item_desc_detail"></h2> */}
                      </div>
                      <div className="custom_cart_item_desc_container">
                        <div className="custom_cart_item_desc_qty">
                          <QTY
                            qty={obj["Count"]}
                            minQty={1}
                            // maxQty={10}
                            maxQty={ProductGroupId === "100702" ? 50 : 10}
                            steps={UnitMeasureId === 61 ? 0.5 : 1}
                            isReadOnly={false}
                            pageLanguage={pageLanguage}
                            NumberToPersianWord={NumberToPersianWord}
                            handleIncrement={() => {
                              if (UnitMeasureId === 61) {
                                setBasketNumber(cartObjects, tempObj["CartDetailId"], 0, 1, 0.5);
                              } else {
                                setBasketNumber(
                                  cartObjects,
                                  tempObj["CartDetailId"],
                                  0,
                                  1,
                                  1,
                                  obj["ItemLength"]
                                );
                              }
                            }}
                            handleDecrement={() => {
                              if (UnitMeasureId === 61) {
                                setBasketNumber(cartObjects, tempObj["CartDetailId"], 0, 1, -0.5);
                              } else {
                                setBasketNumber(
                                  cartObjects,
                                  tempObj["CartDetailId"],
                                  0,
                                  1,
                                  -1,
                                  obj["ItemLength"]
                                );
                              }
                            }}
                            handleInputChange={(value) =>
                              setBasketNumber(cartObjects, tempObj["CartDetailId"], value, 1)
                            }
                          />
                        </div>
                        <div>
                          <p
                            className="custom_cart_item_end_price 9"
                            style={{
                              textDecoration: obj["DiscountPercent"] ? "line-through" : "none",
                            }}
                          >
                            {obj["Price"] === 0
                              ? t("Free")
                              : GetPrice(
                                  obj["UnitPrice"] * obj["Count"],
                                  pageLanguage,
                                  t("TOMANS"),
                                  isTabletOrMobile
                                )}
                          </p>
                        </div>
                      </div>
                    </div>
                    {obj["DiscountedPrice"] !== obj["UnitPrice"] && (
                      <div className="DiscountName_Name">
                        <span className="custom_cart_item_end_price 8" style={{ color: "#ca6667" }}>
                          {pageLanguage === "fa" ? obj["DiscountName"] : obj["DiscountEnName"]}
                        </span>
                        <span className="custom_cart_item_end_price 7" style={{ color: "#ca6667" }}>
                          {obj["Price"] === 0
                            ? t("Free")
                            : GetPrice(
                                obj["DiscountedPrice"] * obj["Count"],
                                pageLanguage,
                                t("TOMANS"),
                                isTabletOrMobile
                              )}
                        </span>
                      </div>
                    )}
                  </li>
                );
                resolve();
              }
            });
          });
      }

      let promiseArr3 = [];
      if (swatches.length) {
        for (let i = 0; i < swatches.length; i++) {
          promiseArr3[i] = new Promise((resolve, reject) => {
            let obj = swatches[i];
            temp1[i + draperies.length + products.length] = (
              <li
                className="custom_cart_item"
                key={"swatches" + i}
                ref={(ref) => (draperyRef.current[swatches[i]["CartDetailId"]] = ref)}
              >
                <div className="custom_cart_item_image_container 4">
                  <img
                    src={imgUrl(obj["PhotoUrl"])}
                    alt=""
                    className="custom_cart_item_img img-fluid"
                  />
                </div>
                <div className="custom_cart_item_desc 4">
                  <div className="custom_cart_item_desc_container">
                    <h1 className="custom_cart_item_desc_name">{t("FABRIC SWATCH")}</h1>
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={() => deleteBasketProject(swatches[i]["CartDetailId"])}
                    />
                  </div>
                  <div className="custom_cart_item_desc_container">
                    <h2 className="custom_cart_item_desc_detail">
                      {(pageLanguage === "en"
                        ? CapitalizeAllWords(obj["DesignEnName"])
                        : obj["DesignName"]
                      ).toString() +
                        " / " +
                        (pageLanguage === "en"
                          ? CapitalizeAllWords(obj["ColorEnName"])
                          : obj["ColorName"]
                        ).toString()}
                    </h2>
                  </div>
                  <div className="custom_cart_item_desc_container">
                    <h2 className="custom_cart_item_desc_detail">
                      {t("Qty: ")}
                      {obj["Count"]}
                    </h2>
                  </div>
                  <div className="custom_cart_item_desc_container"></div>
                  <div className="custom_cart_item_desc_container">
                    <div className="custom_cart_item_desc_qty"></div>
                    <p className="custom_cart_item_end_price 6">
                      {obj["PayableAmount"] === 0
                        ? t("Free")
                        : GetPrice(
                            obj["PayableAmount"],
                            pageLanguage,
                            t("TOMANS"),
                            isTabletOrMobile
                          )}
                    </p>
                  </div>
                </div>
              </li>
            );
            resolve();
          });
        }
      }
      Promise.all([...promiseArr, ...promiseArr3])
        .then(() => {
          setCartItems(temp1);

          dispatch({
            type: SidePriceUpdate,
            payload: { sideCartPrice: totalPrice },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (cartObjects["drapery"] || cartObjects["product"]) {
      if (!Array.isArray(cartObjects.drapery)) {
        cartObjects.drapery = [];
      }

      // کاربر مهمان
      let promiseArr = [];
      let totalPrice = 0;
      let draperiesTotalPrice = 0;
      let productsTotalPrice = 0;
      let totalDiscountedPrice = 0;

      if (cartObjects["drapery"]?.length) {
        promiseArr[0] = new Promise((resolve, reject) => {
          cartCount += cartObjects["drapery"].length;
          totalDiscountedPrice = cartObjects["drapery"].reduce((total, item) => {
            // اگر DiscountedPrice موجود بود، صفر نبود و با Price تفاوت داشت
            if (item.DiscountedPrice && item.DiscountedPrice !== item.Price) {
              return total + item.DiscountedPrice * item.Count;
            } else {
              // در غیر این صورت، از Price استفاده می‌شود
              return total + item.Price * item.Count;
            }
          }, 0);

          resolve(); // به عنوان نمونه resolve می‌کنیم
        });
      }

      if (cartObjects["drapery"]?.length) {
        promiseArr[0] = new Promise((resolve, reject) => {
          cartCount += cartObjects["drapery"]?.length;
          let promiseArr2 = [];
          [...cartObjects["drapery"]].forEach((obj, index) => {
            promiseArr2[index] = new Promise((resolve, reject) => {
              if (obj["ProductId"]) {
                resolve(obj["Price"]);
              } else {
                resolve({ data: obj });
              }
            });
          });
          Promise.all(promiseArr2)
            .then(function(values) {
              let promiseArr3 = [];
              [...cartObjects["drapery"]].forEach((obj1, index) => {
                promiseArr3[index] = new Promise((resolve, reject) => {
                  let bagLength = [...cartObjects["drapery"]].length;

                  if (obj1["ProductId"]) {
                    let obj = obj1;
                    let UnitId = obj["UnitId"];

                    let SewingModelId = obj["SewingModelId"];
                    let ProductGroupId = obj["ProductGroupId"];
                    productsTotalPrice += values[index] * obj["Count"];

                    temp1[bagLength - index - 1] = (
                      <li
                        className="custom_cart_item"
                        key={"products" + index}
                        ref={(ref) => (draperyRef.current[index] = ref)}
                        style={{
                          paddingBottom:
                            obj["DiscountedPrice"] === obj["Price"] ? "1rem" : "2.4rem",
                        }}
                      >
                        <div className="custom_cart_item_image_container 5">
                          <img
                            src={imgUrl(obj["PhotoUrl"])}
                            alt=""
                            className="custom_cart_item_img img-fluid"
                          />
                        </div>

                        <div className="custom_cart_item_desc 5">
                          <div className="custom_cart_item_desc_container">
                            <h1 className="custom_cart_item_desc_name">
                              {pageLanguage === "fa" ? obj["ProductName"] : obj["ProductENName"]}{" "}
                              {pageLanguage === "fa"
                                ? obj["SewingModelName"]
                                : obj["SewingModelEnName"]}
                              {obj["ProductGroupId"] === "10" && t("Fabric By The Meter_bg")}
                            </h1>

                            <button
                              type="button"
                              className="btn-close"
                              aria-label="Close"
                              onClick={() => setBasketNumber(undefined, index, 0, 0)}
                            />
                          </div>
                          <div className="custom_cart_item_desc_container">
                            <h2 className="custom_cart_item_desc_detail">
                              {t("Color: ")}
                              {pageLanguage === "en"
                                ? CapitalizeAllWords(obj["ColorEnName"])
                                : obj["ColorName"]}
                            </h2>
                          </div>

                          {obj["Diameter"] && obj["ProductGroupId"] !== "10" && obj["ProductGroupId"] !== "300301" && obj["ProductGroupId"] !== "100201" && (
                            <div className="custom_cart_item_desc_container">
                              <h2 className="custom_cart_item_desc_detail">
                                <span>{t("Diameter")}:</span>
                                <span style={{ paddingLeft: "0.2rem" }}>
                                  {pageLanguage === "en" ? obj["Diameter"] : obj["Diameter"]}
                                  {t("MM")}
                                </span>
                              </h2>
                            </div>
                          )}

                          {obj["ProductGroupId"] === "100605" && (
                            <div className="custom_cart_item_desc_container">
                              <h2 className="custom_cart_item_desc_detail">
                                <span>{t("Length: ")}</span>
                                <span>
                                  {pageLanguage === "en" ? obj["len"] : obj["len"]}
                                  <span>{t("CM")}</span>
                                </span>
                              </h2>
                            </div>
                          )}

                          {UnitId !== 1 &&
                            ProductGroupId !== "100607" &&
                            ProductGroupId !== "100606" &&
                            ProductGroupId !== "100608" &&
                            ProductGroupId !== "100603" &&
                            ProductGroupId !== "100701" &&
                            ProductGroupId !== "100605" && (
                              <div className="custom_cart_item_desc_container">
                                <h2 className="custom_cart_item_desc_detail">
                                  {t("Size: ")}
                                  {pageLanguage === "en"
                                    ? CapitalizeAllWords(obj["ProductSizeEnName"])
                                    : convertToPersian(obj["ProductSizeName"])}
                                </h2>
                              </div>
                            )}
                          {UnitId !== 1 &&
                            obj.LiningTypeEnName != null &&
                            SewingModelId !== "0303" &&
                            ProductGroupId !== "500204" &&
                            ProductGroupId !== "100607" &&
                            ProductGroupId !== "300301" &&
                            ProductGroupId !== "100606" &&
                            ProductGroupId !== "100608" &&
                            ProductGroupId !== "100603" &&
                            SewingModelId !== "0324" &&
                            SewingModelId !== "0325" &&
                            ProductGroupId !== "100701" &&
                            ProductGroupId !== "300302" &&
                            ProductGroupId !== "300303" &&
                            ProductGroupId !== "300304" &&
                            ProductGroupId !== "100605" && (
                              <div className="custom_cart_item_desc_container">
                                <h2 className="custom_cart_item_desc_detail">
                                  {t("Lining: ")}
                                  {pageLanguage === "fa" ? obj.LiningTypeName : obj.LiningTypeEnName}
                                </h2>
                              </div>
                            )}
                          {(ProductGroupId === "100205" || ProductGroupId === "100204") && (
                            <div className="custom_cart_item_desc_container">
                              <h2 className="custom_cart_item_desc_detail">
                                {t("Control Position: ")}
                                {obj["ControlPosition"] ? t("Right") : t("Left")}
                              </h2>
                            </div>
                          )}
                          {UnitId !== 1 &&
                            obj["ControlPosition"] !== undefined &&
                            (SewingModelId === "0324" || SewingModelId === "0303") && (
                              <div className="custom_cart_item_desc_container">
                                <h2 className="custom_cart_item_desc_detail">
                                  {t("Control Position: ")}
                                  {obj["ControlPosition"] ? t("Right") : t("Left")}
                                </h2>
                              </div>
                            )}
                          {/* <div className="custom_cart_item_desc_container">
                            <h2 className="custom_cart_item_desc_detail"></h2>
                          </div> */}
                          <div className="custom_cart_item_desc_container">
                            <div className="custom_cart_item_desc_qty">
                              <QTY
                                qty={obj["Count"]}
                                minQty={1}
                                // maxQty={10}
                                maxQty={ProductGroupId === "100702" ? 50 : 10}
                                isReadOnly={false}
                                pageLanguage={pageLanguage}
                                NumberToPersianWord={NumberToPersianWord}
                                handleIncrement={() => {
                                  if (
                                    obj["ProductGroupId"] === "10" ||
                                    obj["ProductGroupId"] === "100702"
                                  ) {
                                    setBasketNumber(undefined, obj, 0, 1, 0.5);
                                  } else {
                                    setBasketNumber(undefined, obj, 0, 1, 1);
                                  }
                                }}
                                handleDecrement={() => {
                                  if (
                                    obj["ProductGroupId"] === "10" ||
                                    obj["ProductGroupId"] === "100702"
                                  ) {
                                    setBasketNumber(undefined, obj, 0, 1, -0.5);
                                  } else {
                                    setBasketNumber(undefined, obj, 0, 1, -1);
                                  }
                                }}
                                handleInputChange={(value) =>
                                  setBasketNumber(undefined, obj, value, 1)
                                }
                              />
                            </div>
                            <div>
                              <p
                                className="custom_cart_item_end_price 5"
                                style={{
                                  textDecoration: obj["DiscountPercent"] ? "line-through" : "none",
                                }}
                              >
                                {obj["Price"] === 0
                                  ? t("Free")
                                  : GetPrice(
                                      obj["Price"] * obj["Count"],
                                      pageLanguage,
                                      t("TOMANS"),
                                      isTabletOrMobile
                                    )}
                              </p>
                            </div>
                          </div>
                        </div>
                        {obj["DiscountedPrice"] !== obj["Price"] && (
                          <div className="DiscountName_Name">
                            <span
                              className="custom_cart_item_end_price 4"
                              style={{ color: "#ca6667" }}
                            >
                              {pageLanguage === "fa" ? obj["DiscountName"] : obj["DiscountEnName"]}
                            </span>
                            <span
                              className="custom_cart_item_end_price 3"
                              style={{ color: "#ca6667" }}
                            >
                              {obj["Price"] === 0
                                ? t("Free")
                                : GetPrice(
                                    obj["DiscountedPrice"] * obj["Count"],
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )}
                            </span>
                          </div>
                        )}
                      </li>
                    );
                    resolve();
                  } else {
                    if (
                      values[index] === undefined ||
                      values[index].data === undefined ||
                      values[index].data["Price"] === 0
                    ) {
                      localStorage.removeItem("cart");
                      resolve();
                    } else {
                      let obj = mergeDkFabricCartObj(obj1["PreorderText"] || {}, obj1);
                      draperiesTotalPrice += values[index].data["Price"];
                      let roomName =
                        obj["WindowDescription"] === undefined || obj["WindowDescription"] === ""
                          ? ""
                          : " / " + obj["WindowDescription"];
                      if (obj["SewingModelId"] === "0326") {
                        temp1[bagLength - index - 1] = (
                          <li
                            className="custom_cart_item"
                            key={"drapery" + index}
                            ref={(ref) => (draperyRef.current[index] = ref)}
                          >
                            <div className="custom_cart_item_image_container 6">
                              <img
                                src={imgUrl(obj["PhotoUrl"])}
                                alt=""
                                className="custom_cart_item_img img-fluid"
                              />
                            </div>
                            <div className="custom_cart_item_desc 6">
                              <div className="custom_cart_item_desc_container">
                                <h1 className="custom_cart_item_desc_name">
                                  {pageLanguage === "fa"
                                    ? obj["ModelNameFa"] + " سفارشی "
                                    : "Custom " + obj["ModelNameEn"]}
                                </h1>
                                <button
                                  type="button"
                                  className="btn-close"
                                  aria-label="Close"
                                  onClick={() => setBasketNumber(undefined, index, 0, 0)}
                                />
                              </div>
                              <DkSideCartFabricMiniCart
                                obj={obj}
                                pageLanguage={pageLanguage}
                                t={t}
                              />
                              <div className="custom_cart_item_desc_container">
                                <h2 className="custom_cart_item_desc_detail">
                                  {pageLanguage === "fa"
                                    ? obj["RoomNameFa"] + roomName
                                    : obj["RoomNameEn"] + roomName}
                                </h2>
                              </div>
                      
                              <div className="custom_cart_item_desc_container">
                                <div className="custom_cart_item_desc_qty">
                                  <QTY
                                    qty={obj1["WindowCount"]}
                                    minQty={1}
                                    maxQty={10}
                                    isReadOnly={false}
                                    pageLanguage={pageLanguage}
                                    NumberToPersianWord={NumberToPersianWord}
                                    handleIncrement={() =>
                                      setBasketNumber(undefined, index, 0, 0, 1)
                                    }
                                    handleDecrement={() =>
                                      setBasketNumber(undefined, index, 0, 0, -1)
                                    }
                                    handleInputChange={(value) =>
                                      setBasketNumber(undefined, index, value, 0)
                                    }
                                  />
                                </div>
                                <p className="custom_cart_item_end_price 2">
                                  {GetPrice(
                                    obj1["Price"] * obj1["WindowCount"],
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )}
                                </p>
                              </div>
                            </div>
                          </li>
                        );
                      } else {
                        console.log(`obj`, obj);
                        temp1[bagLength - index - 1] = (
                          <li
                            className="custom_cart_item"
                            key={"drapery" + index}
                            ref={(ref) => (draperyRef.current[index] = ref)}
                          >
                            <div className="custom_cart_item_image_container 7">
                              <img
                                src={imgUrl(obj["PhotoUrl"])}
                                alt=""
                                className="custom_cart_item_img img-fluid"
                              />
                            </div>
                            <div className="custom_cart_item_desc 7">
                              <div className="custom_cart_item_desc_container 1">
                                <h1 className="custom_cart_item_desc_name">
                                  {pageLanguage === "fa"
                                    ? obj["ModelNameFa"] + " سفارشی "
                                    : "Custom " + obj["ModelNameEn"]}
                                </h1>
                                <button
                                  type="button"
                                  className="btn-close"
                                  aria-label="Close"
                                  onClick={() => setBasketNumber(undefined, index, 0, 0)}
                                />
                              </div>
                              {(() => {
                                console.log(`obj`, obj);
                              })()}
                              {
                                obj["FabricDesignEn"] !== null && obj["FabricDesignEn"] !== undefined && (
                                  <div className="custom_cart_item_desc_container custom_cart_item_desc_container_fabrics 3">
                                  {obj["FabricDesignEn"] && (
                                    <h2 className="custom_cart_item_desc_detail">
                                      {pageLanguage === "fa"
                                        ? obj["FabricDesignFa"] + " / " + obj["FabricColorFa"]
                                        : CapitalizeAllWords(
                                            obj["FabricDesignEn"] + " / " + obj["FabricColorEn"]
                                          )}
                                    </h2>
                                  )}
                                 
                                </div>
                                ) 
                              }
                            {obj["FabricDesignEn2"] !== null && obj["FabricDesignEn2"] !== undefined && (
                              <div className="custom_cart_item_desc_container custom_cart_item_desc_container_fabrics 3">
                           
                                {obj["FabricId2"] && (
                                  <h2 className="custom_cart_item_desc_detail">
                                    {pageLanguage === "fa"
                                      ? obj["FabricDesignFa2"] + " / " + obj["FabricColorFa2"]
                                      : CapitalizeAllWords(
                                          obj["FabricDesignEn2"] + " / " + obj["FabricColorEn2"]
                                        )}
                                  </h2>
                                )}
                              </div>
                                 )}
                              {obj["SewingModelId"] !== "0097" &&
                                obj["SewingModelId"] !== "0303" &&
                                obj["SewingModelId"] !== "0327" &&
                                obj["SewingModelId"] !== "0328" &&
                                obj["SewingModelId"] !== "0324" &&
                                obj["SewingModelId"] !== "0325" &&
                                obj["PrivacyLayer"] &&   obj["PrivacyLayer"] !== "None" && (
                                  <>
                                    <div className="custom_cart_item_desc_container custom_cart_item_desc_container_fabrics 4">
                                      {obj["PrivacyLayer"] &&
                                        obj["PrivacyLayer"] !== "None" &&
                                        obj["SheersDesignEn"] &&
                                        obj["SheersColorEn"] && (
                                          <h2 className="custom_cart_item_desc_detail">
                                            {pageLanguage === "fa"
                                              ? obj["SheersDesignFa"] + " / " + obj["SheersColorFa"]
                                              : CapitalizeAllWords(
                                                  obj["SheersDesignEn"] +
                                                    " / " +
                                                    obj["SheersColorEn"]
                                                )}
                                          </h2>
                                        )}
                                    </div>
                                  </>
                                )}
                              <div className="custom_cart_item_desc_container 4">
                                <h2 className="custom_cart_item_desc_detail">
                                  {pageLanguage === "fa"
                                    ? obj["RoomNameFa"] + " / " + obj["WindowDescription"]
                                    : obj["RoomNameEn"] + " / " + obj["WindowDescription"]}
                                </h2>
                              </div>
                              {/* <div className="custom_cart_item_desc_container 5"></div> */}
                              {["0097", "0303", "0327", "0328", "0324", "0325"].includes(
                                obj["SewingModelId"]
                              ) && (
                                <>
                                  <div className="custom_cart_item_desc_container 5.1"></div>
                                </>
                              )}
                              <div className="custom_cart_item_desc_container 6">
                                <div className="custom_cart_item_desc_qty">
                                  <QTY
                                    qty={obj1["WindowCount"]}
                                    minQty={1}
                                    maxQty={10}
                                    isReadOnly={false}
                                    pageLanguage={pageLanguage}
                                    NumberToPersianWord={NumberToPersianWord}
                                    handleIncrement={() =>
                                      setBasketNumber(undefined, index, 0, 0, 1)
                                    }
                                    handleDecrement={() =>
                                      setBasketNumber(undefined, index, 0, 0, -1)
                                    }
                                    handleInputChange={(value) =>
                                      setBasketNumber(undefined, index, value, 0)
                                    }
                                  />
                                </div>
                                <p className="custom_cart_item_end_price 1">
                                  {GetPrice(
                                    obj1["Price"] * obj1["WindowCount"],
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )}
                                </p>
                              </div>
                            </div>
                          </li>
                        );
                      }
                      resolve();
                    }
                  }
                });
              });
              Promise.all(promiseArr3).then(() => {
                resolve();
              });
            })
            .catch((err) => {
              console.log(err);
              reject(err);
            });
        });
      }
      Promise.all(promiseArr)
        .then(() => {
          setCartItems(temp1);
          localStorage.setItem("cart", JSON.stringify(cartObjects));

          dispatch({
            type: SideDiscountedPrice,
            payload: { SideDiscountedPrice: totalDiscountedPrice },
          });

          dispatch({
            type: SidePriceUpdate,
            payload: {
              // sideCartPrice: draperiesTotalPrice + productsTotalPrice,
              sideCartPrice: totalDiscountedPrice,
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setCartItems([]);
      localStorage.setItem("cart", JSON.stringify({}));

      dispatch({
        type: SidePriceUpdate,
        payload: { sideCartPrice: 0 },
      });
    }
  }

  return <ul className="custom_cart_items_container">{cartItems}</ul>;
}

export default RenderSideCart;
